document.querySelectorAll('.parent-nav-btn').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.parent-nav-btn').forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    document.querySelectorAll('.menu-section').forEach(section => section.style.display = 'none');
    document.getElementById(button.getAttribute('data-section') + '-section').style.display = 'block';
  });
});

document.querySelectorAll('.menu-category').forEach(button => {
  button.addEventListener('click', () => {
    const category = button.getAttribute('data-category');
    const parentSection = button.closest('.menu-section');
    parentSection.querySelectorAll('.menu-category').forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    parentSection.querySelectorAll('.menu-items').forEach(item => item.style.display = 'none');
    parentSection.querySelectorAll(`.menu-items.${category}`).forEach(item => item.style.display = 'block');
    const categoryHeading = parentSection.querySelector(`.menu-items.${category} .category-heading`);
    const offset = -200;

    if (categoryHeading) {
      const categoryHeadingPosition = categoryHeading.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top: categoryHeadingPosition, behavior: 'smooth' });
    }
  });
});

window.addEventListener('load', () => {
  setTimeout(() => {
    document.getElementById('food-section').style.display = 'block';
    document.querySelector('.parent-nav-btn[data-section="food"]').classList.add('active');
    document.querySelectorAll('#food-section .menu-items').forEach(item => item.style.display = 'block');
    document.querySelectorAll('.menu-category').forEach(btn => btn.classList.remove('active'));
  }, 100);
});